import { useFirestore } from 'react-redux-firebase';
import uniqid from 'uniqid';
import moment from 'moment';
import { firestoreCollection, docType, durationType } from 'util/constants';
import { deleteModal } from 'util/modal';

const useRecords = () => {
  const firestore = useFirestore();

  const addRecord = (currentProjectId: string, title?: string) => {
    const id = `record-${uniqid()}`;
    const newRecord: IRecord = {
      id: id,
      projectID: currentProjectId,
      date: moment().unix(),
      title: title ?? '',
      keyNumber: '',
      docType: docType.record,
      duration: 15,
      durationType: durationType.sec,
      links: [],
    };
    firestore.collection(firestoreCollection.records).doc(id).set(newRecord);
    return id;
  };

  const removeRecord = async (id: string) => {
    // The server moves the record's clips to Admin › Deleted items (bin.ts, 5 Nov 2026). Before
    // that this dialog promised the files would go, but they were left in storage for ever.
    const confirm = await deleteModal(
      "Delete this record?\n\nIts video files move to Admin › Deleted items, where an admin can restore them for 30 days. After that they're deleted for good.",
    );
    if (confirm) {
      firestore.collection(firestoreCollection.records).doc(id).delete();
    }
  };

  const updateRecord = (id: string, record: Partial<IRecord>) => {
    firestore.collection(firestoreCollection.records).doc(id).update(record);
  };

  return {
    addRecord,
    removeRecord,
    updateRecord,
  };
};

export default useRecords;
